import React from 'react';

const UnacceptedArticleTypes = () => {
  return (
    <React.Fragment>
      <h1>Not Currently Accepted</h1>
      <p>Cureus <strong>does not</strong> accept the following submissions:</p>
      <ul>
        <li className='warning'>
          <strong>Articles on medical student and resident burnout</strong>
          <p>All articles related to stress, anxiety or burnout of medical students or medical professionals in training will be rejected. Articles on stress, anxiety or burnout of practicing, fully trained medical professionals may be accepted at the discretion of the Editors-in-Chief.</p>
        </li>
        <li className='warning'>
          <strong>Mini-reviews</strong>
          <p>All review article submissions should be comprehensive and include all relevant literature.</p>
        </li>
        <li className='warning'>
          <strong>Review protocols</strong>
          <p>All review protocols, including systematic review protocols, will be rejected.</p>
        </li>
        <li className='warning'>
          <strong>Letters to the editor</strong>
          <p>Cureus does not accept or publish letters to the editor.</p>
        </li>
      </ul>
    </React.Fragment>
  )
}

export default UnacceptedArticleTypes;